#import "../fragments/peep-business-card-info-fragment.graphql"

mutation EditAccountBusinessCardField($input: EavPatchInput!) {
    accountEavPatch(input: $input) {
        account {
            ...PeepBusinessCardInfoFragment
        }
    }
}
